import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colourPrimary, colourMaster } from 'Styles/colors.css';

const Tab = styled.li`
  position: relative;
  padding-left: 0;
  padding-right: 0;
  float: left;

  display: flex;
  cursor: default;
  justify-content: center;
  text-align: center;

  &::after {
    position: absolute;
    bottom: -2px;
    opacity: ${props => (
      props.active ? 1 : 0
    )};
    border-radius: 5px;
    background-color: ${colourPrimary};
    width: 50px;
    height: 4px;

    -webkit-transition: all 0.1s linear 0s;
    transition: all 0.1s linear 0s;
    -webkit-backface-visibility: hidden;
    display: block;
    content: '';
    z-index: 125;
  }
`;

const Title = styled.a`
  min-width: initial;
  padding: 15px 20px;
  font-family: 'Montserrat';
  font-weight: 600;
  color: ${colourMaster};
  font-size: 12px;
  min-width: 70px;
  text-transform: uppercase;
  border-color: transparent;

  &:hover {
    color: ${colourMaster};
    opacity: ${props => (
      props.active ? 1 : 0.6
    )};
  }
`;

// eslint-disable-next-line react/prefer-stateless-function
export default class WveSettingsPanelNavTab extends PureComponent {
  render() {
    const { active, name, toggleTab } = this.props;
    return (
      <Tab
        active={active}
      >
        <Title
          active={active}
          role="button"
          onClick={() => { toggleTab(name); }}
        >
          {name}
        </Title>
      </Tab>
    );
  }
}

WveSettingsPanelNavTab.propTypes = {
  name: PropTypes.string.isRequired,
  toggleTab: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/components/WveSettingsPanel/WveSettingsPanelNav/WveSettingsPanelNavTab/WveSettingsPanelNavTab.jsx